<div class="deadlines-filter">
  <div
    class="deadlines-filter__header"
    [ngClass]="{ 'deadlines-filter__header--expanded': isFilterExpanded }"
    (click)="isFilterExpanded = !isFilterExpanded"
  >
    <div class="deadlines-filter__header-title">
      <mat-icon>filter_alt</mat-icon>
      {{ 'DEADLINES.FILTERS.TITLE' | translate }}
    </div>

    <div class="deadlines-filter__header-expand">
      <span *ngIf="isFilterExpanded">{{ 'DEADLINES.FILTERS.SEE_LESS' | translate }}</span>
      <span *ngIf="!isFilterExpanded">{{ 'DEADLINES.FILTERS.SEE_MORE' | translate }}</span>
    </div>
  </div>

  <div class="deadlines-filter__content" *ngIf="isFilterExpanded">
    <div class="deadlines-filter__content-gap-row">
      <div class="deadlines-filter__content-gap-row-column">
        <div class="deadlines-filter__content-gap-row">
          <div class="deadlines-filter__content-gap-row__item flex-1">
            <fc-filter-type-outlined-select
              fxFlex="45"
              [label]="'DEADLINES.FILTERS.FILTER_BY.TITLE' | translate"
              [control]="filterForm.get('dateFilterType')"
              [options]="filterTypeOptions"
            ></fc-filter-type-outlined-select>

            <fc-date-input
              fxFlex="32"
              [control]="filterForm.get('initialDate')"
              [placeholder]="'DEADLINES.FILTERS.DATE_PLACEHOLDER' | translate"
              translateErrorPrefix="DEADLINES.ERRORS"
              [max]="filterForm.get('finalDate').value"
            ></fc-date-input>

            <div class="deadlines-filter__content-gap-row__item__text color-gray">
              {{ 'DEADLINES.FILTERS.TO' | translate }}
            </div>

            <fc-date-input
              fxFlex="32"
              [control]="filterForm.get('finalDate')"
              [placeholder]="'DEADLINES.FILTERS.DATE_PLACEHOLDER' | translate"
              translateErrorPrefix="DEADLINES.ERRORS"
              [min]="filterForm.get('initialDate').value"
            ></fc-date-input>
          </div>
        </div>

        <div class="deadlines-filter__content-gap-row">
          <div class="deadlines-filter__content-gap-row__item flex-1">
            <fc-locations-input [control]="filterForm.get('locations')"></fc-locations-input>
          </div>
        </div>
      </div>
    </div>

    <div class="deadlines-filter__content-gap-column">
      <div class="deadlines-filter__content-row">
        <div class="deadlines-filter__content-row__item flex-2">
          <fc-maintenance-types-input [control]="filterForm.get('maintenanceTypes')"></fc-maintenance-types-input>
          <fc-segments-input [control]="filterForm.get('segments')"></fc-segments-input>
        </div>
      </div>

      <div class="deadlines-filter__content-row">
        <div class="deadlines-filter__content-row__item flex-2">
          <fc-location-groups-input [control]="filterForm.get('locationGroups')"></fc-location-groups-input>
          <fc-companies-input [control]="filterForm.get('companies')"></fc-companies-input>
        </div>
      </div>
    </div>
  </div>
</div>
